<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>

<div *ngIf="pageReady && AccessAllowed" class="p-3 flex flex-column flex-auto">
    <div>
        <div class="text-900 font-medium text-xl mb-3"><h3>Till Product
        </h3></div>
        <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
            <span class="pi pi-info-circle" style="margin-right:2px;"></span>
            Specify the product name and how much it sells for.
        </p>
        <div class="surface-card p-4 shadow-2 border-round">
            <div class="grid formgrid p-fluid">
                <div class="field mb-4 col-12">
                    <label for="deptName" class="font-medium">Product Name</label>
                    <input [(ngModel)]="Product.name" id="classname" type="text" [ngStyle]="{'border-color': (productNameValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" pInputText>
                </div>
                <div *ngIf="!productNameValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Product name.</div>
                <div class="field mb-4 col-12">
                    <label for="colour" class="font-medium">Colour</label>
                    <div style="display:flex; align-items:center; gap:10px; margin-top:6px;">
                        <p-colorPicker [inline]="false" id="colour" [(ngModel)]="Product.colour"></p-colorPicker>
                        <input style="width:140px;" [(ngModel)]="Product.colour" id="hexcolour" type="text" pInputText placeholder="#000000">
                        <div [style.background]="'#' + Product.colour" style="width:38px; height:38px; border-radius:6px; border:1px solid #d1d5db; flex-shrink:0;"></div>
                    </div>
                </div>
                <div class="field mb-4 col-12">
                    <label for="classname" class="font-medium">Price</label><br/>
                    <p-inputNumber [(ngModel)]="Product.price" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="9999"></p-inputNumber>
                </div>
                <div class="field mb-4 col-12">
                    <label for="classname" class="font-medium">Department</label><br/>
                    <p-dropdown [options]="ListDepartments" [(ngModel)]="Product.tilldepartment" placeholder="Select a Department" [showClear]="true" optionLabel="name"></p-dropdown>
                </div>
                <div class="field mb-4 col-12">
                    <label class="font-medium">Kitchen Item</label>
                    <div style="margin-top:6px;">
                        <p-selectButton [options]="kitchenItemOptions" [(ngModel)]="Product.kitchenitem" optionLabel="label" optionValue="value" [style]="{'width': '160px'}"></p-selectButton>
                    </div>
                    <div style="margin-top:8px; display:flex; align-items:center; gap:6px;">
                        <span [ngClass]="Product.kitchenitem ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                              [style.color]="Product.kitchenitem ? '#16a34a' : '#9ca3af'"
                              style="font-size:15px;"></span>
                        <span style="font-size:13px; color:#6b7280;">
                            {{ Product.kitchenitem ? 'This product will appear on the Kitchen Display System' : 'This product will not appear on the Kitchen Display System' }}
                        </span>
                    </div>
                </div>

                <div class="col-12">
                    <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
                    <span class="pi pi-pencil" style="margin-right:8px;"></span>
                    Save Changes</button>
                    &nbsp;
                    <button *ngIf="id !== '0'" pButton pRipple type="button" class="p-button p-element p-button-info w-auto mt-3" [routerLink]="['/tillproductoptionsassign', id]">
                    <span class="pi pi-list" style="margin-right:8px;"></span>
                    Manage Options</button>
                    &nbsp;
                    <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
                    <span class="pi pi-times" style="margin-right:8px;"></span>
                    Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>